import i18n from "i18next";
import { initReactI18next } from "react-i18next";
const lang = ["hr", "en", "de", "sl", "sr"];

i18n.use(initReactI18next).init({
  fallbackLng: "en",
  lng: "hr",
  resources: {
    en: {
      translations: require("./localisation/en/translations.json"),
    },
    hr: {
      translations: require("./localisation/hr/translations.json"),
    },
    sr: {
      translations: require("./localisation/sr/translations.json"),
    },
    sl: {
      translations: require("./localisation/sl/translations.json"),
    },
    de: {
      translations: require("./localisation/de/translations.json"),
    },
  },
  ns: ["translations"],
  defaultNS: "translations",
});

i18n.languages = lang;

const localLang = localStorage.getItem("lang");
if (localLang != null && localLang != undefined) {
  i18n.changeLanguage(localStorage.getItem("lang"));
}

window.Configs = {
  languages: lang,
};

export default i18n;
